import { SelectableItem } from 'src/app/shared/pipes/map-to-selectable-items.pipe'

export class TimeBlock {
  id?: any
  dayName: string
  isoWeekDayNumber: number
  isAvailable: boolean | number
  price: number
  startTime: string
  endTime: string
  blockLengthInMinutes: number
  productId?: number
  memberId?: number
  days?: number[] | SelectableItem[]
}

export enum TimeBlockDays {
  EVERY_DAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7
}

export enum TimeBlockType {
  PRODUCT = 'products',
  MEMBER = 'member'
}
